type SetCookie = (name: string, value: string, domain: string, minutes?: number) => void;
export const setCookie: SetCookie = (name, value, domain, minutes) => {
  let expires = '';
  if (minutes) {
    const date = new Date();
    date.setTime(date.getTime() + minutes);
    expires = `; expires=${date.toUTCString()}`;
  }

  /*
    To make the cookie storage work locally
    the domain property must be left out of the
    document.cookie expression
    https://stackoverflow.com/questions/1134290/cookies-on-localhost-with-explicit-domain
  */
  if (domain.indexOf('localhost') > -1) {
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
    return;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/; domain=${domain}`;
};
